<template>
  <div class="dpi px">
    <div class="list">
      <div class="param-item">
        <div class="name">{{ $t("mouse.dpiLevel") }}</div>
        <a-radio-group
          :value="Number(currentID)"
          class="radio-group"
          @change="onCurrentIDChange"
        >
          <transition-group name="dpi-fade" tag="div" class="dpi-buttons-container">
            <a-radio-button
              class="radio"
              v-for="(color, index) in DPIcolor.slice(0, actualDPIMax)"
              :value="Number(index)"
              :key="`dpi-${index}`"
              :checked="Number(currentID) === Number(index)"
            >
              <div class="color" :style="{ backgroundColor: color }"></div>
              {{ index + 1 }}
              <md-field class="number">
                <span class="md-prefix" v-if="DPIsyn === 0">X</span>
                <md-input
                  class="number-input"
                  :value="xDPI[index]"
                  @blur="onSliderChange(index, $event.target.value, 'x')"
                  @keypress.enter="
                    onSliderChange(index, $event.target.value, 'x')
                  "
                ></md-input>
              </md-field>
              <md-field class="number" v-if="DPIsyn === 0">
                <span class="md-prefix" v-if="DPIsyn === 0">Y</span>
                <md-input
                  class="number-input"
                  :value="yDPI[index]"
                  @blur="onSliderChange(index, $event.target.value, 'y')"
                  @keypress.enter="
                    onSliderChange(index, $event.target.value, 'y')
                  "
                ></md-input>
              </md-field>
            </a-radio-button>
          </transition-group>
        </a-radio-group>
      </div>
      <template v-for="(dpi, index) in xDPI.slice(0, actualDPIMax)">
        <div 
          class="param-item item" 
          :key="index" 
          v-if="index === currentID"
          :class="{ active: index === currentID }"
        >
          <div class="name"></div>
          <div class="xy">
            <div class="x">
              <a-slider
                class="slider"
                :value="Number(xDPI[index])"
                @change="onSliderChange(index, $event, 'x')"
                :max="maxDPI"
                :min="50"
                :tooltipVisible="false"
                :step="50"
              />
            </div>
            <div class="y" v-if="DPIsyn === 0">
              <a-slider
                class="slider"
                :value="Number(yDPI[index])"
                @change="onSliderChange(index, $event, 'y')"
                :max="maxDPI"
                :min="50"
                :step="50"
                :tooltipVisible="false"
              />
            </div>
          </div>
          <a-tooltip placement="right">
            <template slot="title">
              <sketch-picker
                class="picker"
                :value="DPIcolor[index]"
                disableAlpha
                @input="onColorInput(index, $event)"
                :preset-colors="[
                  '#D0021B',
                  '#F5A623',
                  '#F8E71C',
                  '#8B572A',
                  '#7ED321',
                  '#417505',
                  '#BD10E0',
                  '#9013FE',
                  '#4A90E2',
                  '#50E3C2',
                  '#B8E986',
                  '#000000',
                  '#444444',
                  '#888888',
                  '#CCCCCC',
                  '#FFFFFF',
                ]"
              />
            </template>
            <div
              class="color"
              :style="{ backgroundColor: DPIcolor[index] }"
            ></div>
          </a-tooltip>
        </div>
      </template>
      <div class="param-item">
        <div class="name">{{ $t("mouse.dpiXY") }}</div>
        <a-radio-group
          :value="Number(DPIsyn)"
          class="radio-group"
          @change="onOpenChange"
        >
          <a-radio class="radio" :value="1">
            {{ $t("mouse.dpiSync") }}
          </a-radio>
          <a-radio class="radio" :value="0">
            {{ $t("mouse.dpiAsync") }}
          </a-radio>
        </a-radio-group>
      </div>
      <div class="param-item" v-if="shouldShowDPICount">
        <div class="name">{{ $t("mouse.dpiCount") }}</div>
        <div class="dpi-max-control">
          <a-slider
            class="dpi-max-slider"
            :value="DPIStages"
            @change="onDPIMaxChange"
            @afterChange="onDPIMaxAfterChange"
            :min="1"
            :max="8"
            :step="1"
            :tooltipVisible="false"
          />
          <div class="dpi-max-value">{{ DPIStages }}</div>
        </div>
      </div>
      <div class="param-item">
        <div class="name">{{ $t("mouse.dpiButtonSwitch") }}
          <a-popover placement="right">
          <template slot="content">
            <div class="name-question">
              {{ $t("mouse.dpiButtonTip") }}
            </div>
          </template>
          <a-icon class="name-tip" type="question-circle" />
        </a-popover>
        </div>
        <a-radio-group
          :value="Number(getDPIButton)"
          class="radio-group"
          @change="onDPIButtonChange"
        >
          <a-radio class="radio" :value="1">
            {{ $t("mouse.on") }}
          </a-radio>
          <a-radio class="radio" :value="0">
            {{ $t("mouse.off") }}
          </a-radio>
        </a-radio-group>
      </div>
      <div class="param-item" v-if="false">
        <div class="name">{{ $t("mouse.currentDPI") }}</div>
        <a-radio-group
          :value="Number(currentID)"
          class="radio-group"
          @change="onCurrentIDChange"
        >
          <a-radio
            class="radio"
            v-for="(color, index) in DPIcolor"
            :value="Number(index)"
            :key="index"
          >
            {{ index + 1 }}
          </a-radio>
        </a-radio-group>
      </div>
    </div>
    <div class="button" @click="onSave" v-if="false">
      {{ $t("save") }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CMouseAm35Dpi",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      timer: 0,
    };
  },

  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
    ...mapState("mouseAM35", {
      currentID: "currentID",
      xDPI: "xDPI",
      yDPI: "yDPI",
      DPIcolor: "DPIcolor",
      DPIsyn: "DPIsyn",
      DPIStages: "DPIStages",
      getDPIButton: "getDPIButton",
    }),
    DPI() {
      return {
        currentID: Number(this.currentID),
        xDPI: Array.isArray(this.xDPI) ? this.xDPI.map(val => Number(val)) : [],
        yDPI: Array.isArray(this.yDPI) ? this.yDPI.map(val => Number(val)) : [],
        DPIcolor: this.DPIcolor,
        DPIsyn: Number(this.DPIsyn),
        DPIStages: this.DPIStages,
        getDPIButton: Number(this.getDPIButton),
      };
    },
    maxDPI() {
      return 26000;
    },
    // 计算实际的DPIStages值,如果未定义则默认为8
    actualDPIMax() {
      return this.DPIStages !== undefined ? this.DPIStages : 8;
    },
    // 决定是否显示DPI数量控制
    shouldShowDPICount() {
      return this.DPIStages !== undefined;
    },
  },
  mounted() {
    // DPI组件挂载时不再注册window方法，统一由Mouse组件管理
  },
  beforeDestroy() {
    // 组件销毁前清理定时器，避免内存泄漏
    if (this.timer) {
      clearTimeout(this.timer);
      // 离开页面时如果有未保存的操作，立即保存一次
      this.onSave && this.onSave();
    }
  },
  methods: {
    onDPIButtonChange(e) {
      const getDPIButton = Number(e.target.value);
      this.$store.dispatch("mouseAM35/setDPI", {
        ...this.DPI,
        getDPIButton: getDPIButton
      });
      // 专门调用 setDPIButton 方法
      this.$store.dispatch("loader/setAM35DPIButton", { setDPIButton: getDPIButton });
    },
    onOpenChange(e) {
      const DPIsyn = Number(e.target.value);
      const yDPI = DPIsyn === 1 ? 
        [...this.xDPI].map(val => Number(val)) : 
        [...this.yDPI].map(val => Number(val));
      // 保存当前选中的档位
      const currentID = Number(this.currentID);
      this.$store.dispatch("mouseAM35/setDPI", { 
        ...this.DPI, 
        DPIsyn, 
        yDPI, 
        currentID 
      });
      // 确保UI更新后仍然保持选中的档位
      this.$nextTick(() => {
        if (Number(this.currentID) !== currentID) {
          this.$store.dispatch("mouseAM35/setDPI", { ...this.DPI, currentID });
        }
      });
      this.onSave();
    },
    onCurrentIDChange(e) {
      const index = Number(e.target.value);
      
      // 严格验证：确保 index 是有效数字且在范围内
      if (isNaN(index) || index < 0 || index >= this.actualDPIMax) {
        console.warn(`⚠️ Invalid DPI level selected: ${index}, valid range: 0-${this.actualDPIMax - 1}`);
        return; // 拒绝无效值
      }
      
      // 确保选择的档位在actualDPIMax范围内
      if (index < this.actualDPIMax && Number(this.currentID) != index) {
        // 如果DPI值为0，设置一个默认值
        if (!this.xDPI[index] || Number(this.xDPI[index]) === 0) {
          const xDPI = [...this.xDPI].map(val => Number(val));
          xDPI[index] = 50; // 设置默认值为50（最小有效值）
          const yDPI = [...this.yDPI].map(val => Number(val));
          yDPI[index] = Number(this.DPIsyn) === 1 ? 50 : Number(this.yDPI[index]) || 50;
          
          this.$store.dispatch("mouseAM35/setDPI", {
            ...this.DPI,
            currentID: index,
            xDPI,
            yDPI
          });
        } else {
          this.$store.dispatch("mouseAM35/setDPI", {
            ...this.DPI,
            currentID: index,
          });
        }
        // 确保正确设置了currentID
        this.$nextTick(() => {
          if (Number(this.currentID) !== index) {
            this.$store.dispatch("mouseAM35/setDPI", {
              ...this.DPI,
              currentID: index,
            });
          }
        });
        this.onSave();
      }
    },
    onDPIMaxChange(value) {
      // Update UI only
      // 确保当前选中的DPI档位不超过新的最大值
      let newCurrentID = Number(this.currentID);
      if (newCurrentID >= value) {
        newCurrentID = value - 1;
      }
      
      this.$store.dispatch("mouseAM35/setDPI", { 
        ...this.DPI, 
        DPIStages: value,
        currentID: newCurrentID
      });
    },
    onDPIMaxAfterChange(value) {
      // 调用 AM35 专用的 DPI 档位设置协议
      this.$store.dispatch("loader/setAM35DPIStages", { DPIStages: value });
      
      this.onSave();
    },
    onSliderChange(index, value, xy) {
      // 使用 requestAnimationFrame 来优化渲染性能
      window.requestAnimationFrame(() => {
        const processedValue = !isNaN(Number(value,10)) ? Number(value) : 50;
        let normalizedValue = Math.min(
          Math.max(Math.floor(processedValue / 50) * 50, 50),
          this.maxDPI
        );

        // 直接修改状态而不重新创建数组
        // 注意：修改 DPI 数值时不改变 currentID，避免自动切换档位
        if (xy === "x") {
          if (this.DPIsyn === 1) {
            this.$store.dispatch("mouseAM35/setDPI", {
              ...this.DPI,
              xDPI: this.xDPI.map((v, i) => i === index ? normalizedValue : Number(v)),
              yDPI: this.yDPI.map((v, i) => i === index ? normalizedValue : Number(v))
            });
          } else {
            this.$store.dispatch("mouseAM35/setDPI", {
              ...this.DPI,
              xDPI: this.xDPI.map((v, i) => i === index ? normalizedValue : Number(v))
            });
          }
        } else {
          this.$store.dispatch("mouseAM35/setDPI", {
            ...this.DPI,
            yDPI: this.yDPI.map((v, i) => i === index ? normalizedValue : Number(v))
          });
        }
      });

      // 延长防抖时间以减少保存频率
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.onSave, 1500);
    },
    onColorInput(index, e) {
      // 使用 requestAnimationFrame 优化渲染
      window.requestAnimationFrame(() => {
        const color = e.hex ? e.hex : "#" + e.target.value;
        // 直接在 map 中更新颜色，避免创建额外数组
        const DPIcolor = this.DPIcolor.map((c, i) => 
          i === index ? (color.length === 7 ? color : "#000000") : c
        );

        this.$store.dispatch("mouseAM35/setDPI", { 
          ...this.DPI, 
          DPIcolor 
        });

        // 使用防抖延迟保存
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.onSave();
        }, 500);
      });
    },
    onSave() {
      if (this.currentID >= 0) {
        // 保存当前选中的档位ID，并验证其有效性
        const rawCurrentID = Number(this.currentID);
        // 确保 currentID 在有效范围内：0 到 actualDPIMax-1
        const validCurrentID = Math.max(0, Math.min(rawCurrentID, this.actualDPIMax - 1));
        
        // 如果发现异常值，记录警告日志
        if (validCurrentID !== rawCurrentID) {
          console.warn(`⚠️ Invalid currentID detected: ${rawCurrentID}, clamped to valid range: ${validCurrentID} (max: ${this.actualDPIMax - 1})`);
        }
        
        const saveData = {
          currentID: validCurrentID, // 使用验证后的值
          xDPI: this.xDPI.map(Number), // 确保所有值都是数字类型
          yDPI: this.yDPI.map(Number), // 确保所有值都是数字类型
          DPIcolor: this.DPIcolor,
          DPIsyn: Number(this.DPIsyn), // 确保是数字类型
        };
        
        // 只有当DPIStages已定义时才包含它
        if (this.shouldShowDPICount) {
          saveData.DPIStages = this.DPIStages;
        }
        
        this.$store.dispatch("loader/setAM35DPI", saveData);
        
        // 确保保存后仍保持当前选中的档位（使用验证后的值）
        this.$nextTick(() => {
          if (Number(this.currentID) !== validCurrentID) {
            this.$store.dispatch("mouseAM35/setDPI", { 
              ...this.DPI, 
              currentID: validCurrentID
            });
          }
        });
        // this.$message.info(this.$t("loader.saveSuccess"));
      } else {
        this.$message.info(this.$t("mouse.dpiError"));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dpi {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .list {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .param-item {
      @include flex-center;
      width: 1200px;
      justify-content: flex-start;
      padding: 15px 0;
      font-size: 20px;

      .name {
        font-size: 20px;
        width: 180px;
        margin-right: 20px;
        .name-tip {
        color: $primary-color;
        margin-left: 5px;
        cursor: pointer;
      }
      }

      .dpi-buttons-container {
        @include flex-center;
        gap: 0;
      }

      .radio-group {
        @include flex-center;

        .radio {
          @include flex-center;
          height: auto;
          text-align: center;

          .color {
            width: 15px;
            height: 15px;
            border-radius: 2px;
            border: 1px solid #717171;
            margin: 10px auto 5px auto;
          }

          .number {
            width: 80px;
            color: #717171;
            background: #222222;
            letter-spacing: 0;
            padding: 0 5px;
            height: 32px;
            min-height: 32px;
            line-height: 32px;
            border: 0;
            margin: 0px auto 10px auto;

            .number-input {
              width: 50px;
              height: 32px;
              min-height: 32px;
              line-height: 32px;
              text-align: center;
              font-size: 14px;
            }
          }
        }
      }

      .dpi-max-control {
        @include flex-center;
        
        .dpi-range-label {
          font-size: 16px;
          color: #ffffff;
          
          &:first-of-type {
            margin-right: 15px;
          }
          
          &:last-of-type {
            margin-left: 15px;
          }
        }
        
        .dpi-max-slider {
          width: 300px;
        }
        
        .dpi-max-value {
          font-size: 20px;
          color: #ffffff;
          min-width: 20px;
          text-align: center;
          margin-left: 20px;
        }
      }
    }

    .item {
      .radio {
        width: 30px;
        height: 30px;
        border: 2px solid #3c3c3c;
        border-radius: 50%;
        padding: 3px;
        margin-right: 30px;
        cursor: pointer;
      }

      .xy {
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .x,
      .y {
        @include flex-center;
      }

      .y {
        margin-top: 10px;
      }

      .slider {
        width: 300px;
        margin-right: 30px;
      }

      .number {
        width: 90px;
        font-size: 20px;
        color: #717171;
        letter-spacing: 0;
        margin: 0 30px 0 0;
        padding: 0;
        height: 40px;
        min-height: 40px;
        line-height: 40px;

        .number-input {
          width: 100%;
          text-align: center;
        }
      }

      .color {
        width: 30px;
        height: 30px;
        border-radius: 2px;
        border: 1px solid #717171;
      }

      .picker {
        color: #000000;
      }

      &.active {
        background: #222222;

        .radio::before {
          width: 100%;
          height: 100%;
          display: block;
          content: "";
          background-color: $primary-color;
          border-radius: 50%;
        }

        .number {
          color: #ffffff;
        }

        .color {
          border: 1px solid #ffffff;
        }
      }
    }
  }

  .button {
    @include button;
    width: 120px;
    height: 34px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss">
.dpi {
  .info {
    .item {
      .slider {
        padding: 4px 0;
        .ant-slider-rail {
          height: 6px;
          background-color: #717171 !important;
        }

        .ant-slider-track {
          height: 6px;
          background-color: #3c3c3c !important;
        }

        .ant-slider-step {
          height: 6px;
        }

        .ant-slider-handle {
          width: 30px;
          height: 30px;
          margin-top: -12px;
          background-color: #3c3c3c !important;
          border: 0;
          box-shadow: none;
        }
      }

      &.active .slider {
        .ant-slider-track {
          background-color: $primary-color !important;
        }

        .ant-slider-handle {
          background-color: $primary-color !important;
        }
      }
    }
  }
  
  .dpi-max-control {
    .dpi-max-slider {
      padding: 4px 0;
      
      .ant-slider-rail {
        height: 4px;
        background-color: #717171 !important;
      }

      .ant-slider-track {
        height: 4px;
        background-color: $primary-color !important;
      }

      .ant-slider-step {
        height: 4px;
      }

      .ant-slider-handle {
        width: 20px;
        height: 20px;
        margin-top: -7px;
        background-color: $primary-color !important;
        border: 0;
        box-shadow: none;
      }
    }
  }
}

// DPI level transition animations
.dpi-fade-enter-active, .dpi-fade-leave-active {
  transition: all 0.3s ease;
}

.dpi-fade-enter {
  opacity: 0;
  transform: translateX(-20px);
}

.dpi-fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.dpi-fade-move {
  transition: transform 0.3s ease;
}

// 简单粗暴的解决方案 - 直接覆盖ant design的圆角样式
.dpi-buttons-container .ant-radio-button-wrapper {
  transition: all 0.3s ease !important;
  
  &:first-child {
    border-top-left-radius: 6px !important;
    border-bottom-left-radius: 6px !important;
  }
  
  &:last-child {
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
  }
  
  &:not(:first-child) {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  
  &:not(:last-child) {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}

.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}
</style>
